import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "koumoku tsukinCont cwT_1" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "suuryou tsukinCont cwT_2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "tanka tsukinCont cwT_3" }
const _hoisted_8 = { class: "kingaku tsukinCont cwT_4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_CurrencyInput = _resolveComponent("Mo_CurrencyInput")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "input-group-prepend" }, [
          _createElementVNode("span", {
            class: "input-group-text",
            style: {"height":"30px"}
          }, "自")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control form-control-sm",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.c_addchg_section_start) = $event)),
          disabled: _ctx.isDisable
        }, null, 8, _hoisted_3), [
          [_vModelText, _ctx.item.c_addchg_section_start]
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "input-group-append input-group-prepend" }, [
          _createElementVNode("span", {
            class: "input-group-text",
            style: {"height":"30px"}
          }, "～")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control form-control-sm",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.c_addchg_section_end) = $event)),
          disabled: _ctx.isDisable
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.item.c_addchg_section_end]
        ])
      ])
    ]),
    _createElementVNode("td", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control form-control-sm",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.c_addchg_transport) = $event)),
        disabled: _ctx.isDisable
      }, null, 8, _hoisted_6), [
        [_vModelText, _ctx.item.c_addchg_transport]
      ])
    ]),
    _createElementVNode("td", _hoisted_7, [
      _createVNode(_component_Mo_CurrencyInput, {
        modelValue: _ctx.item.cnvFare,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.cnvFare) = $event)),
        class: "form-control form-control-sm",
        style: {"text-align":"right"},
        "decimal-places": 0,
        "allow-negative": false,
        disabled: _ctx.isDisable
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_8, [
      _createVNode(_component_Mo_CurrencyInput, {
        modelValue: _ctx.item.cnvPass,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.cnvPass) = $event)),
        class: "form-control form-control-sm",
        style: {"text-align":"right"},
        "decimal-places": 0,
        "allow-negative": false,
        disabled: _ctx.isDisable
      }, null, 8, ["modelValue", "disabled"])
    ])
  ]))
}